import request from '@/utils/requestV2'
/**
 * 获取字典
 * @param {Object} params 参数
 * @returns
 */
export function dictionary (params) {
  return request.get('/ooh-sys/dict-biz/dictionary', { params })
}
